import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function SystemSection() {
  const phases = [{
    number: '1',
    title: 'Atracción de Clientela Premium',
    description: 'Segmentamos mujeres (y hombres) en tu área con poder adquisitivo alto que buscan activamente tratamientos de bienestar y estética premium. No buscadores de cupones. Clientes que invierten en sí mismos.',
    benefit: 'Clientes que pagan $200+ por visita desde el día uno'
  }, {
    number: '2',
    title: 'Posicionamiento de Lujo',
    description: 'Construimos tu imagen de marca de spa de alto nivel. Fotos profesionales. Reseñas masivas. Una experiencia digital que hace que el cliente sienta el lujo antes de llegar a tu puerta.',
    benefit: '5 estrellas en Google y percepción de spa de élite en 60 días'
  }, {
    number: '3',
    title: 'Retención y Tickets Altos',
    description: 'Sistema de membresías mensuales, paquetes de tratamientos y seguimiento automatizado que convierte una visita en una relación de largo plazo.',
    benefit: 'Ingresos recurrentes predecibles con membresías automatizadas'
  }];
  return <section className="py-20 md:py-28 px-4 bg-carbon relative border-t border-border" data-id="element-210">
      <div className="max-w-6xl mx-auto" data-id="element-211">
        <motion.div className="text-center mb-16 md:mb-24" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-212">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gold tracking-tight" data-id="element-213">
            La Cura — Sistema A.C.E.™ SPA
          </h2>
        </motion.div>

        <motion.div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-12" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-214">
          {phases.map((phase, index) => <motion.div key={index} variants={cardVariants} className="bg-surface border border-border rounded-2xl p-8 relative flex flex-col h-full group transition-colors hover:border-gold/30" data-id="element-215">
              <div className="absolute -top-6 left-8 bg-carbon border border-gold text-gold w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl shadow-[0_0_15px_rgba(242,183,5,0.2)]" data-id="element-216">
                {phase.number}
              </div>

              <div className="mt-6 flex-grow" data-id="element-217">
                <h3 className="text-xl md:text-2xl font-bold text-gold mb-4" data-id="element-218">
                  FASE {phase.number} — {phase.title.toUpperCase()}
                </h3>
                <p className="text-neutral-300 leading-relaxed text-base md:text-lg" data-id="element-219">
                  {phase.description}
                </p>
              </div>

              <div className="mt-8 pt-6 border-t border-border flex items-start gap-3" data-id="element-220">
                <CheckCircle2 className="w-6 h-6 text-emerald shrink-0 mt-0.5" aria-hidden="true" data-id="element-221" />
                <span className="text-sm text-neutral-300 font-medium leading-snug" data-id="element-222">
                  {phase.benefit}
                </span>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}